// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__P89Tn","unreadBadge":"styles_unreadBadge__16XB9","modalContent":"styles_modalContent__3LTOM","modal":"styles_modal__19eNC"};